import NumericInputField from 'components/NumericInputField'
import { useDispatch, useSelector } from 'react-redux'

import { useMediaQuery } from '@material-ui/core'
import { setMintRoyalty } from 'redux/actions/nftActions'
import { isNarrow } from 'util/screenUtils'
import { HelpOutlineTwoTone } from '@material-ui/icons'
import Explain from 'components/Explain'
import { useState } from 'react'

export default function MintAlbumRoyalty() {
  const narrow = isNarrow(useMediaQuery)
  const { mintRoyalty, nftMessage } = useSelector(state => state.nfts)
  const [explainRoyalty, setExplainRoyalty] = useState(false)
  const [helpTarget, setHelpTarget] = useState()
  const dispatch = useDispatch()
  const setRoyalty = (value) => {
    dispatch(setMintRoyalty(value * 10))
  }
  const displayRoyaltyInput = () => {
    return (
      <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>

        <h4 style={{ textAlign: 'center' }}>
          <HelpOutlineTwoTone
            style={{ height: '100%', verticalAlign: 'middle' }}
            size='small'
            color='primary'
            onClick={(event) => {
              setHelpTarget(event.currentTarget)
              setExplainRoyalty(!explainRoyalty)
            }}
          />
          Royalty Percentage
        </h4>
        <NumericInputField
          min={0}
          max={99.9}
          step={0.1}
          fullWidth={false}
          getter={() => {
            return (mintRoyalty / 10).toFixed(1)
          }}
          setter={setRoyalty}
          style={{
            width: '20vw',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        />
      </div>

    )
  }
  const displayExplainRoyalty = () => {
    if (explainRoyalty) {
      const { name } = nftMessage
      return (
        <Explain
          source={{
            description: `You may set a royalty for future purchases of your
          ${name} NFT. You will be paid this percentage
          of the NFT purchase price (after service fees are deducted). Once the NFT is minted,
          the royalty cannot be changed.`,
          }}
          target={helpTarget}
          close={() => setExplainRoyalty(false)}
        />
      )
    }
  }
  const displayBody = () => {
    return (
      <div>

        {displayRoyaltyInput()}
        {displayExplainRoyalty()}
      </div>
    )
  }
  const displayMain = () => {
    return (
      <div
        style={{
          paddingLeft: '1em',
          paddingRight: '1em',
          width: narrow ? '90vw' : '75vw',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <div style={{ padding: '1em' }}>{displayBody()}</div>
      </div>
    )
  }
  return displayMain()
}
